import React from 'react'

import {
  WppActionButton,
  WppAvatar,
  WppIconMore,
  WppIconNavigationMenu,
  WppIconNotificationOn,
  WppIconSearch,
  WppTopbar,
  WppDivider,
  WppTypography,
  WppCard,
  WppSegmentedControl,
  WppSegmentedControlItem,
  WppListItem,
  WppIconChevron,
} from '@platform-ui-kit/components-library-react'
import logoUrl from 'assets/wpp-logo.svg'
import { useTranslation } from 'react-i18next'

import { getHomePreviewData } from './consts'
import styles from './HomePreview.module.scss'
import { PAGE_PREVIEW_ID } from '../consts'

export const HomePreview: React.FC = () => {
  const { t } = useTranslation()
  const { brands, links, workItems } = getHomePreviewData({ t })

  return (
    <div className={styles.homePreview} id={PAGE_PREVIEW_ID}>
      <WppTopbar className={styles.topbar} navigation={[]}>
        <div slot="app" className={styles.app}>
          <WppIconNavigationMenu />
          <img src={logoUrl} alt={t('home.logoAlt')} className={styles.logo} />
        </div>
        <div slot="right" className={styles.actions}>
          <WppActionButton className={styles.helpButton} variant="secondary">
            <WppIconSearch slot="icon-start" className={styles.searchIcon} />
            {t('home.help')}
          </WppActionButton>
          <WppIconMore direction="horizontal" />
          <WppActionButton className={styles.notification} variant="secondary">
            <WppIconNotificationOn slot="icon-start" className={styles.notificationIcon} />
          </WppActionButton>
          <WppAvatar name={t('home.userName')} />
        </div>
      </WppTopbar>
      <WppDivider />
      <div className={styles.body}>
        <div className={styles.linksAndBrandBlock}>
          <WppCard size="l" className={styles.brandCard}>
            <WppSegmentedControl value="brands" className={styles.segmentedControl} size="s">
              <WppSegmentedControlItem value="brands">{t('home.brands')}</WppSegmentedControlItem>
              <WppSegmentedControlItem value="apps">{t('home.apps')}</WppSegmentedControlItem>
            </WppSegmentedControl>
            {brands.map(brand => (
              <WppListItem key={brand.name} className={styles.listItem}>
                <p slot="label">{brand.name}</p>
                <WppAvatar src={brand.src} size="xs" slot="left" />
              </WppListItem>
            ))}
          </WppCard>
          <WppCard size="l" className={styles.linkCard}>
            <WppTypography type="l-strong" slot="header" className={styles.header}>
              {t('home.favouriteLinks')}
            </WppTypography>
            <WppActionButton variant="secondary" slot="actions">
              {t('home.viewAll')}
            </WppActionButton>
            {links.map(link => (
              <WppListItem key={link.name} className={styles.listItem}>
                <p slot="label">{link.name}</p>
                <WppAvatar src={link.src} size="xs" slot="left" />
              </WppListItem>
            ))}
          </WppCard>
        </div>
        <WppCard size="l" className={styles.workCard}>
          <WppTypography type="l-strong" slot="header" className={styles.header}>
            {t('home.recentWork')}
          </WppTypography>
          {workItems.map((workItem, index) => (
            <div key={workItem.title + index} className={styles.workItem}>
              <div className={styles.description}>
                <WppTypography type="s-midi">{workItem.title}</WppTypography>
                <WppTypography type="s-body">{workItem.description}</WppTypography>
                <WppTypography type="xs-body" className={styles.breadcrumb}>
                  {workItem.breadCrumb}
                </WppTypography>
              </div>
              <WppIconChevron direction="right" />
            </div>
          ))}
        </WppCard>
        <div className={styles.cardsImages}>
          <div className={styles.topCardsImages}>
            <WppCard size="m" interactive className={styles.cannesCard}>
              <WppTypography type="xl-heading" className={styles.title}>
                {t('home.news.cannes')}
              </WppTypography>
            </WppCard>
            <div className={styles.pragueAndHumanCards}>
              <WppCard size="m" interactive className={styles.pragueCard}>
                <WppTypography type="m-strong" className={styles.title}>
                  {t('home.news.prague')}
                </WppTypography>
              </WppCard>
              <WppCard size="m" interactive className={styles.humanCard}>
                <WppTypography type="m-strong" className={styles.title}>
                  {t('home.news.humanRights')}
                </WppTypography>
              </WppCard>
            </div>
          </div>
          <div className={styles.bottomCardsImages}>
            <WppCard size="m" interactive className={styles.talentCard}>
              <WppTypography type="m-strong" className={styles.title}>
                {t('home.news.talent')}
              </WppTypography>
            </WppCard>
            <WppCard size="m" interactive className={styles.womenCard}>
              <WppTypography type="m-strong" className={styles.title}>
                {t('home.news.olderWomen')}
              </WppTypography>
            </WppCard>
            <WppCard size="m" interactive className={styles.techCard}>
              <WppTypography type="xl-heading" className={styles.title}>
                {t('home.news.satalia')}
              </WppTypography>
            </WppCard>
          </div>
        </div>
      </div>
    </div>
  )
}
